module.exports = __webpack_public_path__ + "img/logo_new.3f9860f0.svg";